<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('bills.create')" @invoke-method="invokeMethod($event)" action="openVendorInvoiceForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetVendorInvoices(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="bill_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="bills" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openVendorInvoiceForm(props.item)">
                                <td>{{ props.item.bill_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td class="text-center">{{ props.item.invoice_date }}</td>
                                <td class="text-center">{{ props.item.due_date }}</td>
                                <td>{{ props.item.total_amount }}</td>
                                <td>{{ props.item.balance }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="bills"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="vendor_invoice_dialog">
                <v-card>
                    <v-form ref="form_vendor_invoice">
                        <v-card-title>
                            <span class="headline">{{ bill.bill_id ? $t("lang.edit_vendor_invoice") : $t("lang.add_vendor_invoice") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeVendorInvoiceDialog"
                                :dialog-status="vendor_invoice_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="vendor_invoice_dialog"
                                            v-model="bill.bill_id"
                                            :label="$t('lang.bill_id')"
                                            :counter="showCounter(bill.bill_id, 'bills.bill_id')"
                                            :rules="ifValid('bills.bill_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.purchase_order_id"
                                            :label="$t('lang.purchase_order_id')"
                                            :counter="showCounter(bill.purchase_order_id, 'bills.purchase_order_id')"
                                            :rules="ifValid('bills.purchase_order_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.company_id"
                                            :label="`${$t('lang.company_id')} *`"
                                            :counter="showCounter(bill.company_id, 'bills.company_id')"
                                            :rules="ifValid('bills.company_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.billing_address_id"
                                            :label="$t('lang.billing_address_id')"
                                            :counter="showCounter(bill.billing_address_id, 'bills.billing_address_id')"
                                            :rules="ifValid('bills.billing_address_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.shipping_address_id"
                                            :label="$t('lang.shipping_address_id')"
                                            :counter="showCounter(bill.shipping_address_id, 'bills.shipping_address_id')"
                                            :rules="ifValid('bills.shipping_address_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.shipping_carrier_id"
                                            :label="$t('lang.shipping_carrier_id')"
                                            :counter="showCounter(bill.shipping_carrier_id, 'bills.shipping_carrier_id')"
                                            :rules="ifValid('bills.shipping_carrier_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.invoice_number"
                                            :label="$t('lang.invoice_number')"
                                            :counter="showCounter(bill.invoice_number, 'bills.invoice_number')"
                                            :rules="ifValid('bills.invoice_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="bill.invoice_date"
                                            :label="$t('lang.invoice_date')"
                                            :rules="ifValid('bills.invoice_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="bill.due_date"
                                            :label="`${$t('lang.due_date')} *`"
                                            :rules="ifValid('bills.due_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.payment_term_id"
                                            :label="`${$t('lang.payment_term')} *`"
                                            :counter="showCounter(bill.payment_term_id, 'bills.payment_term_id')"
                                            :rules="ifValid('bills.payment_term_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.exchange_rate_id"
                                            :label="`${$t('lang.exchange_rate_id')} *`"
                                            :counter="showCounter(bill.exchange_rate_id, 'bills.exchange_rate_id')"
                                            :rules="ifValid('bills.exchange_rate_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.exchange_rate"
                                            :label="`${$t('lang.exchange_rate')} *`"
                                            :counter="showCounter(bill.exchange_rate, 'bills.exchange_rate')"
                                            :rules="ifValid('bills.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.status_id"
                                            :label="`${$t('lang.status_id')} *`"
                                            :counter="showCounter(bill.status_id, 'bills.status_id')"
                                            :rules="ifValid('bills.status_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.work_order_no"
                                            :label="$t('lang.work_order_no')"
                                            :counter="showCounter(bill.work_order_no, 'bills.work_order_no')"
                                            :rules="ifValid('bills.work_order_no')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.subtotal"
                                            :label="$t('lang.subtotal')"
                                            :counter="showCounter(bill.subtotal, 'bills.subtotal')"
                                            :rules="ifValid('bills.subtotal')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.discount"
                                            :label="$t('lang.discount')"
                                            :counter="showCounter(bill.discount, 'bills.discount')"
                                            :rules="ifValid('bills.discount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.total_amount"
                                            :label="$t('lang.total_amount')"
                                            :counter="showCounter(bill.total_amount, 'bills.total_amount')"
                                            :rules="ifValid('bills.total_amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill.customer_po"
                                            :label="$t('lang.customer_po')"
                                            :counter="showCounter(bill.customer_po, 'bills.customer_po')"
                                            :rules="ifValid('bills.customer_po')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="bill.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('bills.comments')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="bill.bill_id" color="error" @mouseup.left="$refs.delete_bills.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeVendorInvoiceDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveVendorInvoices">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_bills"
                :heading="$t('lang.delete_vendor_invoice')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteBills(bill.bill_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openVendorInvoiceForm" },
                { title: this.$t("lang.refresh"), action: "dbGetVendorInvoices", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.bill_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.invoice_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.due_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.total_amount"), sortable: false, width: "15%" },
                { text: this.$t("lang.balance"), sortable: false, width: "10%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "10%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            bill: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            vendor_invoice_dialog: false,
            dbGetVendorInvoices: _.debounce(this.getBills, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchBills", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.bills) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchBills({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.bills) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetBills");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.bills.bills_filter,
            page: (state) => state.bills.page,
            rules_bills: (state) => state.bills.rules_bills,
            bill_status: (state) => state.options_categories.bill_status,
            bills: (state) => state.bills.bills,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchBills", "saveBill", "deleteBill", "fetchOptions"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openVendorInvoiceForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "bill", params: { id: item.bill_id } });
            } else {
                this.$router.push({ name: "bill" });
            }
        },
        saveVendorInvoices() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_vendor_invoice")) {
                    let body = this.prepForm(this.bill, this.rules_bills);

                    this.saveBill({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getBills();
                                this.closeVendorInvoiceDialog();
                            } else {
                                this.$router.push({ name: "bill", params: { id: data.bill_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteBills(id = null) {
            this.deleteBill({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getBills();
                    this.closeVendorInvoiceDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeVendorInvoiceDialog() {
            this.vendor_invoice_dialog = false;
            this.$refs.delete_bills.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getBills(pg_refresh = false) {
            this.startLoader();

            this.fetchBills({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.vendor_invoice_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.bill_status == 0 || force == true) await this.fetchOptions({ body: { slug: "bill_status", options: 1 } });

            this.finishLoader();
        },
    },
};
</script>
